import { GlFormGroup, GlFormInput, GlModal } from '@gitlab/ui';
import { __, s__ } from '~/locale';
export default {
    name: 'ApprovalsAuth',
    components: {
        GlFormGroup,
        GlFormInput,
        GlModal
    },
    props: {
        isApproving: {
            type: Boolean,
            default: false,
            required: false
        },
        hasError: {
            type: Boolean,
            default: false,
            required: false
        },
        modalId: {
            type: String,
            required: true
        }
    },
    emits: [
        'approve',
        'hide'
    ],
    data () {
        return {
            approvalPassword: ''
        };
    },
    computed: {
        actionPrimaryProps () {
            return {
                text: __('Approve'),
                attributes: {
                    loading: this.isApproving,
                    variant: 'confirm'
                }
            };
        },
        actionCancelProps () {
            return {
                text: __('Cancel')
            };
        },
        inputState () {
            return this.hasError ? false : null;
        },
        invalidFeedback () {
            return this.hasError ? s__('mrWidget|Approval password is invalid.') : null;
        }
    },
    methods: {
        approve (event) {
            event.preventDefault();
            this.$emit('approve', this.approvalPassword);
        },
        onHide () {
            this.approvalPassword = '';
            this.$emit('hide');
        },
        onShow () {
            setTimeout(()=>{
                this.$refs.approvalPasswordInput.$el.focus();
            }, 0);
        }
    }
};
